import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import MoveEmployeeModal from 'modules/locations/components/MoveEmployee'

const MoveEmployeeModalPage = () => {
  const { navigation } = useNavigation()
  const { id, employeeId } = useStrictParams<'id' | 'employeeId'>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.locations.locationsId.employees.fullPath({ id }))
  }

  return <MoveEmployeeModal locationId={id} employeeId={employeeId} onClose={onClose} />
}

export default MoveEmployeeModalPage
